module.exports = __webpack_public_path__ + "static/media/Litten_gaussian2.3656322e.png";